import {css, StyleSheet} from "aphrodite";
import React from 'react';
import Config from "../../config/Config";
import GridStyles from "../../styles/styles";
import MediaQuery from "../../styles/MediaQuery";
import TextDiv from "../containers/TextDiv";
import FeedbackButton from "../FeedbackButton";
import Image from "../containers/Image";
import {Link} from "react-router-dom";

const GetAsbTopMobile = ({extraStyle}) => {
    const styles = StyleSheet.create({
        container: {
            ...GridStyles.define("80px max-content 54px", "minmax(20px, auto) 1fr minmax(20px, auto)"),
            backgroundImage: `url(${Config.images.HEADER_A})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            marginBottom: '100px',
            justifyContent: "center",
            ...MediaQuery.dynamic(1024, {
                backgroundImage: `url(${Config.images.HEADER_A_MOBILE_1020})`
            })
        },
        wrapper: {
            ...GridStyles.setRowCol(2, 2),
            ...GridStyles.define("auto", "minmax(200px, 480px) 37px minmax(200px, 540px)"),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            paddingBottom: '100px'
        },
        textArea: {
            color: Config.colors.SECONDARY_TEXT
        },
        image: {
            ...GridStyles.setRowCol(1, 3),
            maxWidth: 300,
            maxHeight: 350,
            width: "100%",
            height: "auto",
            position: 'absolute',
            bottom: 'calc(-50% + 30px)',
        },
        title: {
            ...GridStyles.setRowCol(1, 1),
            fontSize: 56,
            lineHeight: 1.07,
            fontWeight: "bold",
            textAlign: 'center'
        },
        description: {
            ...GridStyles.setRowCol(3, 1),
            fontSize: 16,
            lineHeight: 1.75,
            textAlign: 'center'
        },
        button: {
            ...GridStyles.setRowCol(5, 1),
            ...MediaQuery.mobile({
                margin: "0 auto"
            })
        },
        headerDownload: {
            ...GridStyles.setRowCol(7, 1),
            fontSize: 13,
            fontWeight: "bold",
            lineHeight: 1.85,
            "> a": {
                color: "white"
            }
        },
        appImages: {
            display: 'flex',
            alignItems: 'center'
        },
        appImage: {
            width: '150px',
            margin: 10
        },
        logoWrapper: {
            width: '60px',
            height: '60px',
            background: '#1A0857',
            borderRadius: 5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20px',
        },
        logo: {
            width: 40,
            height: 40,
        }
    });

    return (
        <div className={css(styles.container, extraStyle)}>
            <div className={css(styles.wrapper)}>
                <div className={css(styles.logoWrapper)}>
                    <Image extraStyle={styles.logo} src={Config.images.HEADER_BROWSER_LOGO}/>
                </div>
                <div className={css(styles.textArea)}>
                    <TextDiv extraStyle={styles.title} text={Config.messages.secureBrowsing}/>
                    <TextDiv extraStyle={styles.description} text={Config.messages.secureBrowsingSub}/>
                </div>
                <div className={css(styles.appImages)}>
                    <Link to={{ pathname: "https://play.google.com/store/apps/details?id=com.avast.android.secure.browser"}} target="_blank"><Image extraStyle={styles.appImage} src={Config.images.PLAY_STORE}/></Link>
                    <Link to={{ pathname: "https://apps.apple.com/tr/app/apple-store/id1517761023"}} target="_blank"><Image extraStyle={styles.appImage} src={Config.images.APP_STORE}/></Link>
                </div>
                <Image extraStyle={styles.image} src={Config.images.SWITCH}/>
            </div>
        </div>
    );
};

export default GetAsbTopMobile;
